import { Link } from 'react-router-dom';
import { Alert, Box, Heading, Spinner } from '@hyphen/hyphen-components';

import { useResource } from '../lib/session.js';
import { formatWhen } from './evidence-shared.jsx';
import { ProposedChanges } from './proposal.jsx';

/**
 * Everything waiting on a decision, oldest first.
 *
 * Proposals live on the control they change, which is where they are decided —
 * but an editor who has to open every control to find out there is something
 * waiting will not find out.
 */
export function Pending() {
  const { data: proposals, error } = useResource('/proposals');

  if (error) return <Alert variant="danger">{error}</Alert>;
  if (!proposals) return <Spinner />;

  return (
    <Box gap="3xl" maxWidth="60rem">
      <Heading as="h1" size="lg">Pending changes</Heading>

      {proposals.length === 0 && (
        <Box color="secondary">Nothing is waiting on a decision.</Box>
      )}

      <Box gap="xl">
        {proposals.map((proposal) => (
          <Box
            key={proposal.id}
            gap="md"
            padding="lg"
            radius="md"
            borderWidth="sm"
            borderColor="subtle"
            background="primary"
          >
            <Box direction="row" alignItems="baseline" gap="sm" fontSize="sm">
              <Link to={`/admin/controls/${proposal.hai_id}`}>{proposal.hai_id}</Link>
              <Box as="span" fontWeight="medium">{proposal.proposed_by}</Box>
              <Box as="span" color="secondary">{formatWhen(proposal.created_at)}</Box>
            </Box>

            <Box as="p" style={{ whiteSpace: 'pre-wrap' }}>{proposal.note}</Box>

            <ProposedChanges changes={proposal.changes} />

            <Box fontSize="sm">
              <Link to={`/admin/controls/${proposal.hai_id}`}>
                Open {proposal.hai_id} to decide
              </Link>
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  );
}
